<div>
  <ng-content *ngTemplateOutlet="customSidebar() || defaultSidebar"></ng-content>
</div>

<ng-template #defaultSidebar>
  <div
    id="viewsManager"
    [style.top]="sidebarPositionTop()"
  >
    <div
      id="additionalSidebarContainer"
      [class.hidden]="hideSidebarToolbar()"
    >
      <pdf-sidebar-toolbar [mobileFriendlyZoomScale]="mobileFriendlyZoomScale()"></pdf-sidebar-toolbar>
    </div>
    <pdf-sidebar-content
      [customThumbnail]="customThumbnail()"
      (thumbnailDrawn)="thumbnailDrawn.emit($event)"
      [hideSidebarToolbar]="hideSidebarToolbar()"
      [mobileFriendlyZoomScale]="mobileFriendlyZoomScale()"
    ></pdf-sidebar-content>
    <div id="viewsManagerResizer" class="sidebarResizer"></div>
  </div>
</ng-template>
